import React, { Component } from 'react';

import { getErrorMessage } from '../../../util/responseUtil';
import API_AUTHENTICATION from '../../../api/apiAuthentication';
import LoginBackground from '../../../assets/images/login-background.svg';
import OutsideLogo from '../../../components/Common/OutsideLogo';
import Alert from '../../../components/Alert/Alert';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            versionRelease: '',
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.state.email === '') return this.setState({ showErrorAlert: true })

        const data = {
            email: this.state.email
        }

        API_AUTHENTICATION.postResetPassword(data)
            .then(res => {
                this.setState({ showSuccessAlert: true })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
            })
    }

    render() {
        return (
            <div className="w-screen h-screen bg-white relative">
                <OutsideLogo />
                <img alt="Login Background" src={LoginBackground} className="w-full h-full object-contain" />
                <form onSubmit={this.handleSubmit} className="absolute top-60 right-56 w-96 text-gray-600">
                    <p className="text-3xl font-bold">Atur Ulang Kata Sandi</p>
                    <div className="quote font-medium mt-5 mb-20">
                        <p>Masukkan alamat email Anda dan kami akan mengirimkan Anda Link untuk mengatur ulang kata sandi Anda.</p>
                    </div>
                    <input
                        type="text"
                        id="tslemail"
                        name="email"
                        placeholder="Masukkan Email"
                        autoComplete="off"
                        onChange={this.handleChange}
                        className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                    />
                    <button type="submit" id="btnsend" className="bg-darkblue w-full h-16 text-center text-white outline-none rounded mt-10">Kirim</button>
                </form>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Silahkan Cek Email Anda!" />
                <Alert show={this.state.showErrorAlert} icon="warning" title="Email tidak boleh kosong!" close={() => this.setState({ showErrorAlert: false })} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </div>
        );
    }
}

export default ResetPassword;